import { useLocation, useNavigate, useParams } from "react-router-dom";
import Footer from "../components/footer";
import Header from "../components/header";
import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import DataTable from "react-data-table-component";
import ReadMoreParagraph from "../../admin/components/ReadMoreParagraph";
import { CartContext } from "../../../contexts/cartContext";
import { CurrencyContext } from "../../../contexts/currencyContext"; // Import context
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import RequestModal from "../components/RequestModal";
import LoaderHomePd from "../components/loaderHomePd";


const Artworks = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { categoryId, subCategoryId, typeId, searchText } = location.state || {}; // Retrieve categoryId from route state
    const { styleId, surfaceId, subjectId, materialId } = useParams();
    // Extract parameters from the URL
    const { categoryName, styleName, surfaceName, subjectName, mediumName } = useParams();
    
    const [wishlists, setWishlists] = useState([]);
    const { wishlist, addToWishlist } = useContext(CartContext);

    const [artworkList, setArtworkList] = useState([]);
    const [isFiltered, setIsFiltered] = useState(false); // State to differentiate between "all" and "filtered" artworks

    
    const [loading, setLoading] = useState(true);
    

    // State for Style dropdown
    const [styles, setStyles] = useState([]);
    const [selectedStyle, setSelectedStyle] = useState(0);

    // State for dropdown Surface 
    const [surfaces, setSurfaces] = useState([]);
    const [selectedSurface, setSelectedSurface] = useState(0);

    // State for dropdown Subject 
    const [subject, setSubjects] = useState([]);
    const [selectedSubject, setSelectedSubject] = useState(0);

    // State for dropdown Medium/Material 
    const [medium, setMediums] = useState([]);
    const [selectedMedium, setSelectedMedium] = useState(0);

    // State for dropdown Orientation 
    const [size, setSizes] = useState([]);
    const [selectedSize, setSelectedSize] = useState(0);

    // State for dropdown Orientation 
    const [orientation, setOrientations] = useState([]);
    const [selectedOrientation, setSelectedOrientation] = useState(0);

    // State for dropdown Price nRange 
    const [priceRange, setPriceRanges] = useState([]);
    const [selectedPriceRange, setSelectedPriceRange] = useState(0);

    // State for dropdown Sorting 
    const [sorting, setSorting] = useState([]);
    const [selectedSorting, setSelectedSorting] = useState(0);

    const { currencyContxt } = useContext(CurrencyContext); // Use context

    const getArtworkAll = async (safeCategoryId, safeSubCategoryId, safeTypeId) => {
        
        const url = `https://igapi.heuristticminds.com/api/UserInterface/Get-GetArtworkDetailsByCategorySubCategoryID?category_id=${safeCategoryId}&SubCategory_id=${safeSubCategoryId}&Type_id=${safeTypeId}&searchText=${searchText}`;
        try {
            const response = await axios.get(url);
            const artworkData = response.data;

            if (artworkData.length > 0) {
                const artwork = artworkData[0]; // Assuming you have at least one artwork
            
            if (subCategoryId === 1) {
                setSelectedStyle(safeTypeId); // subCategoryId = 1 corresponds to Style dropdown
            } else if (subCategoryId === 2) {
                setSelectedSurface(safeTypeId); // subCategoryId = 2 corresponds to Surface dropdown
            } else if (subCategoryId === 3) {
                setSelectedSubject(safeTypeId); // subCategoryId = 3 corresponds to Subject dropdown
            }else if (subCategoryId === 4) {
                setSelectedMedium(safeTypeId); // subCategoryId = 4 corresponds to Medium dropdown
            }
                setSelectedSize(0);
                setSelectedOrientation(0);
                setSelectedPriceRange(0);
                setSelectedSorting(0);
                // If you have more ids to set, do it here
            }
            setLoading(true);
            const delay = new Promise(resolve => setTimeout(resolve, 500)); // 500 ms delay
            await delay;
            setArtworkList(artworkData);
            setIsFiltered(false); // Mark the state as not filtered
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }


    const getFilteredArtworks = async (filters) => {
        
        const {
            selectedStyle,
            selectedSurface,
            selectedSubject,
            selectedMedium,
            selectedSize,
            selectedOrientation,
            selectedPriceRange,
            selectedSorting,
        } = filters;
    
        const url = `https://igapi.heuristticminds.com/api/UserInterface/Get-GetArtworkDetailsByFilter?category_id=${categoryId}&style_id=${selectedStyle}&surface_id=${selectedSurface}&subject_id=${selectedSubject}&medium_id=${selectedMedium}&size_id=${selectedSize}&orientation_id=${selectedOrientation}&priceRange_id=${selectedPriceRange}&sort_id=${selectedSorting}`;
        try {
            const response = await axios.get(url);
            setArtworkList(response.data);
            setIsFiltered(true); // Mark the state as filtered
        } catch (error) {
            console.log(error);
        }
    };

    // Function to Fetch data from API for dropdown
    const fetchData = async (url, setData) => {
        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

   // Trigger fetch when initial IDs change
   useEffect(() => {
        const safeCategoryId = categoryId || 0;
        const safeSubCategoryId = subCategoryId || 0;
        const safeTypeId = typeId || 0;

        if (location.state) {
            // Reset dropdowns based on subCategoryId
            switch (safeSubCategoryId) {
                case 1: // Style
                    setSelectedStyle(safeTypeId);
                    setSelectedSurface(0); // Reset Surface
                    setSelectedSubject(0); // Reset Subject
                    setSelectedMedium(0); // Reset Medium
                    break;
                case 2: // Surface
                    setSelectedSurface(safeTypeId);
                    setSelectedStyle(0); // Reset Style
                    setSelectedSubject(0); // Reset Subject
                    setSelectedMedium(0); // Reset Medium
                    break;
                case 3: // Subject
                    setSelectedSubject(safeTypeId);
                    setSelectedStyle(0); // Reset Style
                    setSelectedSurface(0); // Reset Surface
                    setSelectedMedium(0); // Reset Medium
                    break;
                case 4: // Medium
                    setSelectedMedium(safeTypeId);
                    setSelectedStyle(0); // Reset Style
                    setSelectedSurface(0); // Reset Surface
                    setSelectedSubject(0); // Reset Subject
                    break;
                default:
                    // Don't reset dropdowns unnecessarily
                break;
            }
        }

        // Fetch artworks based on categoryId, subCategoryId, and typeId
        getArtworkAll(safeCategoryId, safeSubCategoryId, safeTypeId);
    }, [categoryId, subCategoryId, typeId]);


    
    useEffect(() => {
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindStyleByArtwork?artwork=' + categoryId, setStyles);
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindSurfaceByArtwork?artwork=' + categoryId, setSurfaces);
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindSubjectByArtwork?artwork=' + categoryId, setSubjects);
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindMaterialByArtwork?artwork=' + categoryId, setMediums);
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-SizeList', setSizes);
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-OrientationList', setOrientations);
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-PriceRangeList', setPriceRanges);
    }, [categoryId]);


    
    
    useEffect(() => {
        debugger;
        getFilteredArtworks({
            selectedStyle,
            selectedSurface,
            selectedSubject,
            selectedMedium,
            selectedSize,
            selectedOrientation,
            selectedPriceRange,
            selectedSorting,
        });
    }, [selectedStyle, selectedSurface, selectedSubject, selectedMedium, selectedSize, selectedOrientation, selectedPriceRange, selectedSorting]);
 
     /* const handleDropdownChange = async () => {
        debugger;
        await getFilteredArtworks();
    };  */

    const handleGenericChange = (event) => {
        debugger;
        const { name, value } = event.target;
        const selectedValue = value ? parseInt(value, 10) : 0; // Handle empty values

        switch (name) {
            case 'style':
                setSelectedStyle(selectedValue);
                break;
            case 'surface':
                setSelectedSurface(selectedValue);
                break;
            case 'subject':
                setSelectedSubject(selectedValue);
                break;
            case 'medium':
                setSelectedMedium(selectedValue);
                break;
            case 'size':
                setSelectedSize(selectedValue);
                break;
            case 'orientation':
                setSelectedOrientation(selectedValue);
                break;
            case 'priceRange':
                setSelectedPriceRange(selectedValue);
                break;
            case 'sorting':
                setSelectedSorting(selectedValue);
                break;
            default:
                break;
        }

        //handleDropdownChange();
    };

    const handleClearFilters = () => {
        
        setSelectedStyle(0);
        setSelectedSurface(0);
        setSelectedSubject(0);
        setSelectedMedium(0);        
        setSelectedSize(0);
        setSelectedOrientation(0);
        setSelectedPriceRange(0);
        setSelectedSorting(0);
       
        const safeCategoryId = categoryId || 0;
        getArtworkAll(safeCategoryId, 0, 0);
          
    };

    const handleViewAllArtworks = () => {
        handleClearFilters();    
    };

    //Dynamic URL Starts

    // Function to construct the dynamic URL
    const constructURL = () => {
        let url = `/artworks/painting`;

        if (selectedStyle) url += `/${styles.find(s => s.id === selectedStyle)?.style.toLowerCase() || ''}`;
        if (selectedSurface) url += `/${surfaces.find(s => s.id === selectedSurface)?.surface.toLowerCase() || ''}`;
        if (selectedSubject) url += `/${subject.find(s => s.id === selectedSubject)?.subject.toLowerCase() || ''}`;

        return url;
    };
     // Initialize dropdowns based on URL and state
     useEffect(() => {
        if (styleName) {
            const foundStyle = styles.find(s => s.style.toLowerCase() === styleName.toLowerCase());
            if (foundStyle) setSelectedStyle(foundStyle.id);
        }

        if (surfaceName) {
            const foundSurface = surfaces.find(s => s.surface.toLowerCase() === surfaceName.toLowerCase());
            if (foundSurface) setSelectedSurface(foundSurface.id);
        }

        if (subjectName) {
            const foundSubject = subject.find(s => s.subject.toLowerCase() === subjectName.toLowerCase());
            if (foundSubject) setSelectedSubject(foundSubject.id);
        }
    }, [styleName, surfaceName, subjectName]);

     


    //Dynamic URL Ends


    //Wishlist Click
    const userInfo = JSON.parse(localStorage.getItem('user-info'));
    // Fetch the wishlist data when the page loads
    const fetchWishlistData = async () => {
                
        if (userInfo && userInfo.buyer_id) {
            try {
                const response = await fetch(`https://igapi.heuristticminds.com/api/WishList/Get-GetWishListByUserID?user_id=${userInfo.buyer_id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const wishlistData = await response.json();

                if (wishlistData && Array.isArray(wishlistData)) {
                    setWishlists(wishlistData); // Store complete wishlist items from API
                } else {
                    setWishlists([]); // Set an empty wishlist if no data is returned
                }

            } catch (error) {
                console.error('Error fetching wishlist:', error);
            }
        } else {
            const localWishlist = getWishlistFromLocalStorage();
            setWishlists(localWishlist); // Store complete wishlist items from local storage
        }
    };

    // Handler for Wishlist Button Click
    const handleWishlistClick = async(item) => {
        
        const itemIsInWishlist = isInWishlist(item.product_id);

        if (userInfo && userInfo.buyer_id) {

            try {
                const payload = {
                    customer_id: userInfo.buyer_id,
                    product_id: item.product_id,
                };
                    const response = await fetch("https://igapi.heuristticminds.com/api/WishList/Add-SaveWishList", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                });
                    
                if (!response.ok) {
                    throw new Error(`Failed to update wishlist: ${response.statusText}`);
                }
    
                // Extract JSON data from the response
                const { action } = await response.json(); // Destructuring to get action flag
    
    
                // Display success message based on the action performed
                if (action === "Add") {
                    toast.success("Artwork Added to Wishlist !!");
                } else if (action === "Remove") {
                    toast.error("Artwork Removed from Wishlist !!");
                }
                    // Fetch the updated wishlist after modification
                    await fetchWishlistData();  // Refresh state with the updated wishlist from the database
            } catch (error) {
                console.error("Error syncing wishlist item:", item.product_id, error);
            }
        }
        else{
            if (itemIsInWishlist) {
                // Remove from wishlist logic
                removeFromWishlist(item.product_id);
                toast.error("Artwork Removed from Wishlist 2 !!");
            } else {
                addToWishlist(item);
                toast.success("Artwork Added to Wishlist !!");
            }
        }
        

        handleWishlistUpdate(); // Refresh wishlist state after adding/removing
    };

    // Helper function to get wishlist from localStorage
    const getWishlistFromLocalStorage = () => {
        return JSON.parse(localStorage.getItem('wishlist')) || [];
    };

    // Context or state management function
    const handleWishlistUpdate = () => {
        
        if (userInfo && userInfo.buyer_id) {
            fetchWishlistData(); // Fetch from API
        } else {
            const updatedWishlist = getWishlistFromLocalStorage(); // Fetch from local storage
            setWishlists(updatedWishlist); // Update state
        }        
    };
    const isInWishlist = (productId) => {
        return wishlists.some(item => item.product_id === productId);
    };

    // Function to remove item from the wishlist
    const removeFromWishlist = (productId) => {
        const updatedWishlist = wishlists.filter(item => item.product_id !== productId);
        setWishlists(updatedWishlist); // Update state
        localStorage.setItem('wishlist', JSON.stringify(updatedWishlist)); // Update local storage
    };

    useEffect(() => {
        const loadWishlist = async () => {
            await fetchWishlistData();
        };
        loadWishlist();
    }, []);
    useEffect(() => {
        setWishlists(wishlist);
    }, [wishlist]); // This will trigger every time the wishlist state changes


    //WishList Click ends

    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [selectedPd, setSelectedPd] = useState(null);

    const handleRequestPrice = (id, pdTitle) => {
        setModalOpen(true);
        setSelectedId(id);
        setSelectedPd(pdTitle);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedId(null);
        setSelectedPd(null);
    };

    const columns = [
        {
            cell: (row) => {
                const isInWishlist = wishlists.some(item => item.product_id === row.product_id);
                return (
                    <div className="pd_item" key={row.product_id}>
                        <div className="img_box">
                            <img src={`../../../images/products/thumbnail/${row.image}`} className="pd_img" alt="" />
                            <a href="#" className="wishlist_link" title="WISHLIST" onClick={async(e) => {
                                e.preventDefault();
                                //addToWishlist(row); // Add or remove item from wishlist
                                handleWishlistClick(row); // Updated function                               

                            }}>
                                <i className={`${isInWishlist ? 'bi bi-suit-heart-fill text-danger' : 'bi bi-suit-heart'}`}></i>
                            </a>
                            <span className="q_view" onClick={() => handleDetails(row.product_id, row.productTitle)}>
                                <i className="bi bi-eye"></i> Quick View
                            </span>
                            <span className="size">Size: <b>{row.size}</b></span>
                        </div>
                        <div className="pd_content">
                            <span className="pd_brand">{row.productTitle}</span>
                            <span className="pd_title">{row.artwork}: {row.categoryType}</span>
                            <span className="pd_title">Art by:
                                <span className="btn_artist1" onClick={() => handleArtist(row.artist_id, row.artistName)}>
                                    {row.artistName}
                                </span>
                            </span>
                            {
                                row.price_on_demand === 1 ? <><span className="btn_req" onClick={() => handleRequestPrice(row.product_id, row.productTitle)}>Request Price</span></> :

                                    <div className="Price">
                                        {currencyContxt.icon} {(row.price / currencyContxt.value).toFixed(2)}
                                        {
                                            row.discountRate === 0 ? ''
                                                : <>
                                                    <span className="old_price">{currencyContxt.icon} {((row.gstMRP) / currencyContxt.value).toFixed(2)}</span><span className="discount">({row.discountRate}%)</span>
                                                </>
                                        }
                                        {
                                            currencyContxt.currency == "INR" ?
                                                <small>Including GST</small>
                                                :
                                                <></>
                                        }
                                    </div>
                            }

                        </div>
                    </div>
                );
            }
        },
    ];
    const paginationComponentOptions = {
        noRowsPerPage: true
    };



    const handleDetails = (id, productTitle) => {
        const formattedTitle = productTitle.replace(/ /g, '-'); // Replace spaces with '-'
        navigate(`/artwork/${formattedTitle}-${id}`, { state: { id: id}});
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
    };

    const handleArtist = (artistId, artistName) => {
        const artist = artistName.replace(/ /g, '-'); // Replace spaces with '-'
        navigate(`/artist/${artist}-${artistId}`, { state: { artistId: artistId}});
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
    };

    const introText = `So if you are here, you have made the correct choice of preferring <b>IndiGalleria</b> to buy ${artworkList[0]?.category} from emerging, experienced and renowned Indian artists. We have a collection of <b>${artworkList.length}</b> Original ${artworkList[0]?.category} For Sale which will give you an impeccable shopping experience for home decor, hotels and corporate or investment purposes not forgetting paintings as a token of gift to your loved ones to make them feel the delicacy of owning a ${artworkList[0]?.category}. Think maybe twice, but not thrice, about where to buy original handmade artworks online, go for IndiGalleria. We sell absolutely original and authentic artworks. To know what is original artwork and Reasons to buy it do visit our blog! `;
    const TextAboutGalleria = `<b>IndiGalleria</b> is one of the best online art galleries having an enormous collection of original paintings, whether it is acrylic, oil, watercolour, mixed media or charcoal, or any painting to be made on your special demand, your wishes will not be left unfulfilled. Even if you are looking for Abstract, Figurative, Contemporary, Indian Folk Art like Madhubani or Figurative Paintings depicting Indian culture you will get to choose from a lot of masterpiece collections. Landscape or seascape paintings are also available in hyper-realistic, realistic and abstract forms. If you wish to buy mythological paintings like Buddha, Ganesha, Radha-Krishna etc you will get a different style of artwork in one place. We have also extended our reach to provide you paintings of animals which includes horses, bulls, cows, monkeys, dogs and fish paintings at the best price. IndiGalleria is committed to providing art lovers to buy original authentic paintings online. Write us at info@indigalleria.com in case of a bulk order of original artworks. `;


    return (
        <>
            <Header />
            <div style={{ marginTop: '150px' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 mb-4">
                            <h2 className="sec_title">Original {artworkList[0]?.category} for Sale</h2>
                            <ReadMoreParagraph text={introText} maxLength={300} />
                        </div>
                        <div className="row">
                            <div className="col-md-12 filter_list">
                                <div className="row">
                                    <div className="col-sm p-1">
                                        <select name="style" value={selectedStyle} onChange={handleGenericChange} className="form-select">
                                            <option value={0}>-Style-</option>
                                            {Array.isArray(styles) && styles.map((styleName) => (
                                                <option key={styleName.id} value={styleName.id}>
                                                    {styleName.style}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-sm p-1">
                                        <select name="surface" value={selectedSurface} onChange={handleGenericChange} className="form-select">
                                            <option value={0}>-Surface-</option>
                                            {Array.isArray(surfaces) && surfaces.map((surfaceName) => (
                                                <option key={surfaceName.id} value={surfaceName.id}>
                                                    {surfaceName.surface}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-sm p-1">
                                        <select name="subject" value={selectedSubject} onChange={handleGenericChange} className="form-select">
                                            <option value={0}>-Subject-</option>
                                            {Array.isArray(subject) && subject.map((subjectName) => (
                                                <option key={subjectName.id} value={subjectName.id}>
                                                    {subjectName.subject}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-sm p-1">
                                        <select name="medium" value={selectedMedium} onChange={handleGenericChange} className="form-select">
                                            <option value={0}>-Material-</option>
                                            {Array.isArray(medium) && medium.map((mediumName) => (
                                                <option key={mediumName.id} value={mediumName.id}>
                                                    {mediumName.medium}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-sm p-1">
                                        <select name="size" value={selectedSize} onChange={handleGenericChange} className="form-select">
                                            <option value={0}>-Size-</option>
                                            {Array.isArray(size) && size.map((sizeName) => (
                                                <option key={sizeName.id} value={sizeName.id}>
                                                    {sizeName.size}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-sm p-1">
                                        <select name="orientation" value={selectedOrientation} onChange={handleGenericChange} className="form-select">
                                            <option value={0}>-Orientation-</option>
                                            {Array.isArray(orientation) && orientation.map((orientationType) => (
                                                <option key={orientationType.id} value={orientationType.id}>
                                                    {orientationType.orientation}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-sm p-1">
                                        <select name="priceRange" value={selectedPriceRange} onChange={handleGenericChange} className="form-select">
                                            <option value={0}>-Price Range-</option>
                                            {Array.isArray(priceRange) && priceRange.map((range) => (
                                                <option key={range.id} value={range.id}>
                                                    {range.priceRange}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-sm p-1">
                                        <select name="sorting" value={selectedSorting} onChange={handleGenericChange} className="form-select">
                                            <option value={0}>-Sort-</option>
                                            <option value={1}>Price : Low to High</option>
                                            <option value={2}>Price : High to Low</option>
                                        </select>
                                    </div>
                                </div>


                            </div>
                            <div className="col-md-12 text-end pe-0">
                                <button className="btn_req me-2" onClick={handleClearFilters}>Clear All</button>
                                <button className="btn_req" onClick={handleViewAllArtworks}>View All Artworks</button>
                            </div>
                        </div>
                        <div className="col-md-12 pd-list">
                            {
                                loading ? (<LoaderHomePd />
                                ) : (
                                    <DataTable
                                        columns={columns}
                                        data={artworkList}
                                        pagination
                                        noTableHead
                                        paginationComponentOptions={paginationComponentOptions}
                                        paginationPerPage={[20]}
                                    />
                                )}
                        </div>

                        <div className="col-sm-12 mb-5">
                            <h2 className="sec_title">About IndiGalleria</h2>
                            <ReadMoreParagraph text={TextAboutGalleria} maxLength={380} />
                        </div>
                    </div>

                </div>
            </div>
            <ToastContainer position="bottom-right" />
            <RequestModal isOpen={isModalOpen} onClose={handleCloseModal} id={selectedId} pdTitle={selectedPd} />
            <Footer />
        </>
    )
}

export default Artworks;